import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import NavigationHeader from "./components/NavigationHeader";
import KineticHero from "./components/KineticHero";
import EditorialMarquee from "./components/EditorialMarquee";
import ManifestoChapters from "./components/ManifestoChapters";
import RevivoSection from "./components/RevivoSection";
import CompanyStory from "./components/CompanyStory";
import BeforeAfterSection from "./components/BeforeAfterSection";
import ConfiguratorCTA from "./components/ConfiguratorCTA";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";
import ImpressumPage from "./components/ImpressumPage";
import DatenschutzPage from "./components/DatenschutzPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function LandingPage() {
  return (
    <>
      <NavigationHeader />
      <main>
        <KineticHero />
        <EditorialMarquee />
        <ManifestoChapters />
        <RevivoSection />
        <CompanyStory />
        <BeforeAfterSection />
        <ConfiguratorCTA />
        <ContactSection />
      </main>
      <FooterSection />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App bg-[#050B14] text-slate-100 min-h-screen" data-testid="app-root">
        <div className="grain-overlay" />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
        </Routes>
        <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#0A1526", border: "1px solid rgba(0,229,255,0.25)", color: "#F1F5F9" } }} />
      </div>
    </BrowserRouter>
  );
}

export default App;
